




























































































































































import BaseLogin from '@/components/login/base-login-page.vue';
import { validEmail } from '@/helpers/validEmail';
import * as service from '@/services/auth';
import Component from 'vue-class-component';
import BaseAccess from './base-access.vue';
import StarRating from 'vue-star-rating'

@Component({
  components: {
    BaseLogin,
    StarRating
  },
})
export default class ForgotPassword extends BaseAccess {
  emailOuCelular = 'email';
  titulo = 'Recuperação de senha';
  unblock = false;
  starRating: number;

  public user: any = {
    username: null,
    email: null,
    celular: null,
    justification: null,
  };

  public form: any = {
    valid: false,
    rules: {
      username: [(v) => !!v || 'Digite o CPF ou o CRM', (v) => !/[^A-Z|0-9|\.|\-]/gi.test(v) || 'Usuário inválido'],
      email: [(v) => !!v || 'Digite o E-mail', (v) => !v || validEmail(v) || 'Digite um e-mail válido'],
      celular: [(v) => !!v || 'Digite o Celular', (v) => !v || v.length > 9 || 'Digite um celular válido'],

      code: [(v) => !!v || 'Informe o código recebido por SMS'],
      justification: [(v) => !!v || 'Informe a justificativa'],
      starRating: [(v) => !!v || 'Informe uma nota de 0 a 5'],
      password: [
        (v) => !!v || 'Digite a Nova Senha',
        (v) => (!!v && /\d/g.test(v)) || 'A senha precisa ter pelo menos um numero',
        (v) => (!!v && /[A-Z]/g.test(v)) || 'A senha precisa ter pelo menos um caractere maiúsculo',
        (v) => (!!v && /[a-z]/g.test(v)) || 'A senha precisa ter pelo menos um caractere minúsculo',
        (v) => (!!v && /[^\w\d]/g.test(v)) || 'A senha precisa ter pelo menos um caractere especial',
        (v) => (!!v && v.length > 5) || 'A senha precisa ter no mínimo 6 caracteres',
      ],
    },
  };

  public mounted(): void {    
    if (this.$route.meta && this.$route.meta.title) {
      this.titulo = this.$route.meta.title;
    }
    let usernameUnblock = sessionStorage.getItem('usernameUnblock');
    if (usernameUnblock) {
      this.unblock = true;
      this.user.username = usernameUnblock;
      sessionStorage.removeItem('usernameUnblock');
    }
    setTimeout(() => {
      this.$refs['user.username'].focus();
      this.msg = 'Nesta etapa precisamos confirmar seus dados por questões de segurança.';
    }, 200);
  }

  public esqueciSenhaIniciar(): void {
    this.$refs.form.validate();
    if (!this.form.valid && this.step == this.STEP_CONFIRM_CPF_EMAIL) {
      return;
    }

    this.msg = null;
    this.msgErro = null;
    this.loader.start('Processando...');

    service.forgotPasswordInit(this.user.username, this.user.email, this.user.celular).subscribe(
      (res) => {
        this.esqueciSenhaIniciarResult = res;
        this.msg = res.msg;
        this.step = this.STEP_CONFIRM_SMS_CODE;
        this.loader.stop();
        setTimeout(() => {
          this.$refs['user.validationCode'].focus();
        }, 200);
      },
      (error) => {
        this.msgErro = error.data.message;
        this.timeoutResetMsgErro();
        this.loader.stop();
      },
    );
  }

  public esqueciSenhaJustificar() {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.msg = null;
    this.msgErro = null;
    this.loader.start('Validando...');
    let instance = this;

    service
      .forgotPasswordJustifyInativ(this.esqueciSenhaIniciarResult.uuid, this.user.validationCode, this.user.justification, this.starRating)
      .subscribe(
        (res) => {
          this.loader.stop();
          if (this.unblock) {
            this.dialog.show(
              'alert',
              'Usuário ativado com sucesso',
              'Lembramos que a inatividade suspende automaticamente seu acesso, não deixe de prescrever conosco. Você será encaminhado para o login',
              'OK',
              () => {
                instance.$router.push('/login');
              },
            );
            return;
          }
          this.step = this.STEP_NEW_PASSWORD;
          setTimeout(() => {
            this.$refs['user.novaSenha'].focus();
          }, 200);
        },
        (error) => {
          this.$refs['user.justification'].focus();
          this.msgErro = error.data.message;
          this.timeoutResetMsgErro();
          this.loader.stop();
        },
      );
  }
}
